import { UserModel } from '../api.service';

export const userMockData: UserModel[] = [
  new UserModel({
    createdBy: 'Admin',
    createdDate: new Date(),
    email: 'john.doe@sgits.co.za',
    failedLoginAttempts: 3,
    firstname: 'John',
    isActive: true,
    isActiveDirectoryUser: true,
    lockoutExpiryDate: null,
    resetPasswordOnNextLogin: false,
    roles: [],
    lastname: 'Doe',
    id: 'bcbb724b-8120-4d92-9e13-a41e015317e8',
    username: 'john.doe',
    lastModifiedBy: 'Admin',
    lastModifiedDate: new Date()
  }),
  new UserModel({
    createdBy: 'Admin',
    createdDate: new Date(),
    email: 'jane.doe@sgits.co.za',
    failedLoginAttempts: 3,
    firstname: 'Jane',
    isActive: true,
    isActiveDirectoryUser: true,
    lockoutExpiryDate: null,
    resetPasswordOnNextLogin: false,
    roles: [],
    lastname: 'Doe',
    id: '07c54d3b-8800-4d47-9b43-cf1c7a5f4b84',
    username: 'jane.doe',
    lastModifiedBy: 'Admin',
    lastModifiedDate: new Date()
  })
];
